<template>
  <nav class="header">
    <div>
      <!--      <el-menu mode="horizontal" @select="handleSelect">-->
      <el-menu mode="horizontal">
        <img src="@/assets/logo.png" class="logo" alt="logo"/>
<!--        <img src="../assets/webName.png" class="webName" alt="logo"/>-->
        <el-menu-item index="1" style="font-size: 20px" @click="handleToPage('/')">首页</el-menu-item>
        <el-sub-menu index="2">
          <template  #title >
            <div style="font-size: 20px;text-align:center">学习工具</div></template>
          <el-row style="width: 450px">
            <el-col :span="8">
              <img src="@/assets/picture/weChatMini.jpg"
                   style="width: 150px;height: 150px"
                   alt="mini"/>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <img src="@/assets/picture/weChatMini.png"-->
<!--                   style="width: 100px;height: 100px"-->
<!--                   alt="mini"/>-->
<!--            </el-col>-->
            <el-col :span="8">
              <img src="@/assets/picture/weChatGongZhong.jpg"
                   style="width: 150px;height: 150px"
                   alt="gongzhong"/>
            </el-col>
            <el-col :span="8">
              <img src="@/assets/picture/useInduction.png"
                   style="width: 150px;height: 150px"
                   alt="useInduction"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">微信小程序</el-col>
<!--            <el-col :span="8">微信小程序</el-col>-->
            <el-col :span="8">微信公众号</el-col>
            <el-col :span="8">资料信息（微信扫一扫）</el-col>
          </el-row>
<!--          <el-menu-item index="1" style="font-size: 20px">安卓平台</el-menu-item>-->
<!--          <el-menu-item index="2" style="font-size: 20px">IOS平台</el-menu-item>-->
<!--          <el-menu-item index="3" style="font-size: 20px">微信小程序</el-menu-item>-->
        </el-sub-menu>
        <el-sub-menu index="3">
          <template  #title ><div style="font-size: 20px;text-align:center">项目内容</div></template>
          <el-menu-item index="1" @click="handleToPage('/fire/mediumFireDeviceHome')">消防设施操作员中级</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="4" v-if="!isLogin" style="font-size: 20px" @click="handleToPage('/login')">登录/注册</el-menu-item>
        <el-sub-menu index="4" v-if="isLogin">
          <template #title>
            <div style="font-size: 20px;" >{{ nickName }}</div></template>
<!--          <el-menu-item index="1" v-show="!isLogin" @click="handleToPage('/register')">注册</el-menu-item>-->
<!--          <el-menu-item index="2" v-show="!isLogin" @click="handleToPage('/login')">登录</el-menu-item>-->
          <el-menu-item index="3" v-show="isLogin" @click="handleToPage('/userInfo/userInfoHome')">个人资料</el-menu-item>
          <el-menu-item index="4" v-show="isLogin" @click="logout">登出</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

  </nav>
</template>

<script>
import {ref} from "vue";
import router from "@/router";

const isLogin = ref(false);

function getNickName() {
  let nickName = localStorage.getItem("loginNickName");
  if (nickName == null) {
    return "登录";
  }
  isLogin.value = true;
  return nickName;
}

export default {
  name: "MainHeader",
  data() {
    return {
      nickName: getNickName(),
      isLogin: isLogin.value,
    }
  },
  methods: {
    handleToPage(path){
      setTimeout( () => {
        router.push({path: path});
      },500)
    },

    logout(){
      if (localStorage.getItem('loginNickName')) {
        localStorage.removeItem('loginNickName');
      }
      if (localStorage.getItem('userToken')) {
        localStorage.removeItem('userToken')
      }
      if (localStorage.getItem('loginUserName')) {
        localStorage.removeItem('loginUserName')
      }
      if (localStorage.getItem('loginUserId')) {
        localStorage.removeItem('loginUserId')
      }
      this.$message.warning("登出成功");
      isLogin.value=false;
      setTimeout( () => {
        location.reload();
      },500);
    }
  },
}
</script>

<style scoped>
.logo {
  width: 250px;
  height: 60px;
}

.header {
  position: -webkit-sticky;
  position: sticky;
  top: 0; /* 设置距离页面顶部的距离 */
  background-color: #fff;
  z-index: 1000; /* 确保导航栏在最上方 */
}

/*.el-sub-menu {*/
/*  background-color: #f0f0f0;*/
/*}*/

/* 如果需要深度选择 */
:deep(.el-sub-menu__title) {
  color: #333;
  font-size:18px ;
}

.el-menu {
  background-color: #f0f0f0;
}
.el-sub-menu{
  background-color: transparent !important;
  color: black !important;
  width: 200px;
  font-size: 18px;
  text-align: center !important;
}
/*.el-sub-menu .el-sub-menu__title {*/
/*  display: flex;*/
/*  align-items: center !important;*/
/*  justify-content: center !important;*/
/*}*/

.el-menu-item {
  background-color: transparent !important;
  color: black !important;
  font-weight: 40;
  width: 200px;
  font-size: 18px;
  text-align: center;
&:not(.is-disabled):hover {
   color: gray !important;
   background-color: lightgray !important;
   width: 200px;
   text-align: center;
 }
}

.el-menu--popup {
  min-width: 200px !important;
  min-height: 100px !important;
}

</style>
